<template>
  <div :id="`card-${item.item_id}`" class="card">
    <figure class="card-image-box">
      <img
        :src="item.image_path"
        :alt="$domUtils.decode(item.item_name)"
        class="card-image">
    </figure>
    <div class="card-contents">
      <div class="card-header">
        <p class="card-name">{{ $domUtils.decode(item.item_name) }}</p>
        <p class="card-price">{{ item.amount }}</p>
      </div>
      <div
        class="card-body"
        ref="accordion" 
        :style="{ height: accordionHeight }"
      >
        <p class="card-note" v-html="injectedHTML" ref="content" />
      </div>
      <div class="card-like">
        <button
          class="card-like-button"
          @click="toggleHeart"
          :disabled="isLocked"
        >
          <i class="card-like-icon fa-heart" 
            :class="[bookmarked ? 'fas' : 'far']"
          ></i>
        </button>
      </div>
    </div>
    <button class="card-accordion mobile-only"
      @click="toggleAccordion"
    >
      <i class="fas fa-chevron-down card-accordion-icon" 
        :class="{ 'is-open': accordionIsOpened }"
      ></i>
    </button>
  </div>
</template>

<script>
import { sanitizeHTML } from '@/utils/dom'
import initInjectedHTML from '@/utils/init-injected-html'

export default {
  props: {
    item: { type: Object, required: true },
    isLocked: { type: Boolean, required: true }
  },

  data() {
    return {
      accordionIsOpened: false,
      accordionHeight: '',
      loading: false,
      bookmarked: this.item.bookmarked,
    }
  },

  computed: {
    injectedHTML() {
      return sanitizeHTML(this.item.description)
    }
  },

  methods: {
    toggleHeart() {
      if (this.loading) {
        return false
      }

      this.loading = true
      this.bookmarked = !this.item.bookmarked

      this.$emit('bookmark', this.item)
    },
    toggleAccordion() {
      this.accordionIsOpened = !this.accordionIsOpened

      if (this.accordionIsOpened) {
        this.slideDown()
      } else {
        this.slideUp()
      }
    },
    slideDown() {
      const targetMaxHeight = this.$refs.accordion.children[0].clientHeight
      let targetHeight = 0
      const heightPerTime = targetMaxHeight / 50
      const slideDown = () => {
        const slideDownTimer = setInterval(() => {
          targetHeight += heightPerTime
          this.accordionHeight = `${targetHeight}px`
          if (targetHeight >= targetMaxHeight) {
            clearInterval(slideDownTimer)
            this.accordionHeight = 'auto'
          }
        }, 5)
      }
      slideDown()
    },
    slideUp() {
      let targetHeight = this.$refs.accordion.children[0].clientHeight
      const heightPerTime = targetHeight / 50
      const slideUp = () => {
        const slideUpTimer = setInterval(() => {
          targetHeight -= heightPerTime
          this.accordionHeight = `${targetHeight}px`
          if (targetHeight <= 0) {
            clearInterval(slideUpTimer)
            this.accordionHeight = 0
          }
        }, 5)
      }
      slideUp()
    },
  },

  watch: {
    injectedHTML: {
      handler() {
        this.$nextTick(() => {
          initInjectedHTML(this.$refs.content)
        })
      },
      immediate: true
    },
    item: {
      handler() {
        this.loading = false
        this.bookmarked = this.item.bookmarked
      },
      deep: true
    }
  },
}
</script>
